import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { CircularProgress, Box, Typography } from '@mui/material';
import { AppContext } from '../AppContext';
import Swal from 'sweetalert2';

interface SoporteGuardProps {
    children: React.ReactNode;
}

const SoporteGuard: React.FC<SoporteGuardProps> = ({ children }) => {
    const context = useContext(AppContext);
    const navigate = useNavigate();
    const [checked, setChecked] = useState(false);

    const getIsSoporte = (): boolean => {
        if (context?.data.isSoporte) return true;
        try {
            const localData = JSON.parse(localStorage.getItem('data') || '{}');
            return !!localData.isSoporte;
        } catch {
            return false;
        }
    };

    useEffect(() => {
        const isSoporte = getIsSoporte();

        if (!isSoporte) {
            Swal.fire({
                icon: 'warning',
                title: 'Acceso restringido',
                text: 'Esta sección solo está disponible para personal de soporte.',
                confirmButtonText: 'Volver al inicio',
            }).then(() => {
                navigate('/home', { replace: true });
            });
            return;
        }

        setChecked(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context?.data.isSoporte, navigate]);

    if (!checked) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6, width: '100%' }}>
                <CircularProgress />
                <Typography color="text.secondary">Verificando permisos...</Typography>
            </Box>
        );
    }

    return <>{children}</>;
};

export default SoporteGuard;
